'use strict';

var _mintelUserTracking = require('mintel-user-tracking');

var _mintelUserTracking2 = _interopRequireDefault(_mintelUserTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.mintel_tracking = _mintelUserTracking2.default;